import React from "react";
import Heap from "react-heap";

export default () => {
  if (process.env.NODE_ENV === "production")
    return (
      <Heap
        appId="2773601494"
        userId="john@snow.com"
        userData={{ firstName: "Prod", lastName: "Snow" }}
      />
    );

  return (
    <Heap
      appId="2187950220"
      userId="john@snow.com"
      userData={{ firstName: "Dev", lastName: "Snow" }}
    />
  );
};
